/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Design_Settings_Primary_Content_DescInputs */

const en_admin_design_settings_primary_content_desc = /** @type {(inputs: Admin_Design_Settings_Primary_Content_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text and icon color on elements using the primary color.`)
};

const de_admin_design_settings_primary_content_desc = /** @type {(inputs: Admin_Design_Settings_Primary_Content_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schrift- und Symbolfarbe auf Elementen in der Primärfarbe.`)
};

/**
* | output |
* | --- |
* | "Text and icon color on elements using the primary color." |
*
* @param {Admin_Design_Settings_Primary_Content_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_design_settings_primary_content_desc = /** @type {((inputs?: Admin_Design_Settings_Primary_Content_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Design_Settings_Primary_Content_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_design_settings_primary_content_desc(inputs)
	return en_admin_design_settings_primary_content_desc(inputs)
});